// extracted by mini-css-extract-plugin
module.exports = {"overlay":"AppModal_overlay__3B7Dc","container":"AppModal_container__2JAZ8","card":"AppModal_card__1Ikm9","content":"AppModal_content__1nsW1"};